<template>

  <header class="header">
    <div class="container-fluid">
      <div class="header__wrapper">
        <div class="header__left">
          <router-link :to="{ name: 'EmployeeApplicationsList'}" class="header__logo">
            <svg viewBox="0 0 241 32" width="241" height="32">
              <use xlink:href="@/assets/v2/img/sprite.svg#header__logo"></use>
            </svg>
          </router-link>
          <nav class="header__nav">
            <ul class="header__menu flex">
              <li class="header__menu__item">
                <router-link :to="{ name: 'EmployeeApplicationsList' }"
                             class="header__menu__link"
                             :class="{'link--active': $route.matched.some(item => item.name === 'EmployeeApplicationsLayout')}">
                  {{ $lang.app.APPLICATIONS }}</router-link>
              </li>
              <li v-if="this.$store.getters.isRegistrator" class="header__menu__item">
                <router-link :to="{ name: 'EmployeeReports' }"
                             class="header__menu__link"
                             :class="{'link--active': $route.matched.some(item => item.name === 'EmployeeReports')}">
                  {{ this.$lang.app.REPORTS }}</router-link>
              </li>
            </ul>
          </nav>
        </div>
        <div class="header__right">
          <Notifications/>
          <div class="button__dropdown" :class="{'opened': dropdownOpen}" @click="dropdownOpen = !dropdownOpen">
            <div class="header__user">
              <div class="header__user__avatar">
                <img v-if="avatar"
                     :src="`data:${avatar.mimeType};base64, ${avatar.base64}`"
                     alt="Avatar"
                     class="header__user__avatar__img">
                <img v-else
                     class="header__user__avatar__img"
                     src="@/assets/icons/user.png"
                     alt="Avatar"
                />
              </div>
              <div class="header__user__info">
                <div class="header__user__title">{{ $store.getters.getCurrentUser.employment.surname }} {{ $store.getters.getCurrentUser.employment.name[0] }}.</div>
                <div class="header__job__title"
                     :title="$lang.$translate({ ru: $store.getters.getCurrentUser.employment.position.nameRu, kg: $store.getters.getCurrentUser.employment.position.nameKg })
                      + ' | ' + $lang.$translate({ ru: $store.getters.getCurrentUser.employment.position.department.nameRu, kg: $store.getters.getCurrentUser.employment.position.department.nameKg })"
                >{{ $lang.$translate({ ru: $store.getters.getCurrentUser.employment.position.nameRu, kg: $store.getters.getCurrentUser.employment.position.nameKg }) }}</div>
              </div>
              <svg viewBox="0 0 24 24" width="24" height="24"><use xlink:href="@/assets/v2/img/sprite.svg#chevron__down"></use></svg>
            </div>
            <ul class="dropdown__list min-w-max right-0" :class="{'opened': dropdownOpen}">
              <li class="dropdown__item">
                <router-link :to="{ name: 'EmployeeProfileDetail' }"
                             class="dropdown__link"
                             @click.prevent="dropdownOpen = false">{{ $lang.app.PROFILE }}
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__user"></use>
                  </svg>
                </router-link>
              </li>
              <li class="dropdown__item">
                <a class="dropdown__link cursor-pointer" @click="logout">{{ $lang.app.LOGOUT }}
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__exit"></use>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>

</template>

<script>
import Notifications from "./Notifications";

export default {
  components: {
    Notifications,
  },
  data() {
    return {
      isOpen: false,
      dropdownOpen: false,
    };
  },
  computed: {
    isSidebarSlidable() {
      return this.$route.meta.sidebar === 'slidable'
    },
    avatar() {
      return this.$store.getters.getCurrentUser.photo
    },
    role() {
      return localStorage.getItem("role");
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "Login" })
      });
    },
  },
};
</script>
